angular.module("dx.webapp.exam", [
	"dx.webapp.examDuration",
	"dx.webapp.node",
	"dx.webapp.question",

	"dx.ui.components.localize",
	"dx.ui.dataTypes.grading",
	"dx.ui.components.onlineResources",
	"dx.ui.utils",
]);
